import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["tab", "trigger"];

  connect() {
    if (window.location.hash) {
      const trigger = this.triggerTargets.find(
        (trigger) => trigger.dataset.tab === window.location.hash
      );
      this.openTab(trigger);
    }
  }

  open(event) {
    this.openTab(event.currentTarget);
  }

  openTab(triggerElement) {
    this.tabTargets.forEach((tab) => tab.classList.add("d-none"));
    this.triggerTargets.forEach((trigger) =>
      trigger.classList.remove("active")
    );
    const tabToOpen = document.querySelector(triggerElement.dataset.tab);
    triggerElement.classList.add("active");
    tabToOpen.classList.toggle("d-none");
  }
}
